var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  }),
                  _vm._v(" "),
                  _c("GetFormField")
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(_vm.$t("insert.status")) + ":")]),
                  _vm._v(
                    " " + _vm._s(_vm.rowData.Status && _vm.rowData.Status.Label)
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              {
                attrs: { title: _vm.$t("insert.customer.Customer"), active: "" }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(" " + _vm._s(_vm.$t("get.Stock.Warehouse")))
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.Warehouse &&
                                _vm.rowData.Warehouse.Label
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(" " + _vm._s(_vm.$t("get.Stock.UnitSet")))
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.UnitSet && _vm.rowData.UnitSet.Label
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(" " + _vm._s(_vm.$t("get.Stock.Unit")))
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.rowData.Unit && _vm.rowData.Unit.Label)
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(" " + _vm._s(_vm.$t("get.Stock.Item")))
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.rowData.Item && _vm.rowData.Item.Label)
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(" " + _vm._s(_vm.$t("get.Stock.Quantity")))
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.Quantity))])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38de1404", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38de1404","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/WarehouseStock/get.vue
// module id = null
// module chunks = 